const AFFECTATION = {
  title: 'Gestion des affectations',
  titleListeAfecctation: 'Liste des affectations logistiques affichage',
  titlePopUp: 'Souhaitez vous forcer l’affectation ?',
  titlePopUpMultiAffectationCommande: 'Liste des affectations à la commande de la face {face}',
  titlePopUpMultiAffectationReseau: 'Liste des affectations au(x) réseau(x) tempo de la face {face}',
  messDescriptionPopup: 'La face sélectionnée est déjà affectée. Forcer l’affectation peut avoir un impact sur la liste des demandes d’affichages.',
  breadcrumb: {
    racine: 'Accueil',
    listeDemande: 'Liste des demandes affichages',
    gestionAffectation: 'Gestion des affectations',
    listeAffectation: 'Liste des affectations logistique affichage',
  },
  success: {
    affectation: 'La/les faces ont bien été affectée(s)',
    desaffectation: 'La/les faces ont bien été désaffectée(s)',
  },
  actions: {
    search: 'Rechercher',
    affecter: 'Affecter',
    desaffecter: 'Désaffecter',
    inclureNonCommercialisable: 'Inclure non comm.',
    cancel: 'Retour',
    forcer: 'Forcer',
    close: 'Fermer',
  },
  informationCommande: {
    title: 'Commande n°{codeCommande} - {annonceur}',
    actionLogistique: 'Action à réaliser : {action}',
    theme: 'Thème : {theme}',
    plusdinfo: 'Plus d\'information',
    societe: 'Les affections logistiques que vous souhaitez voir ne sont pas sur la société courante.',
  },
  informationProduit: {
    title: 'Demande logistique',
    actionLogistique: 'Action à réaliser : {action}',
    plusdinfo: 'Plus d\'information',
    date: 'Date de réalisation : {date}',
  },
  tab: {
    face: 'Code Face',
    format: 'Format',
    materiel: 'Matériel',
    adresse: 'Adresse',
    restriction: 'Restriction',
    commande: 'Visuel à poser',
    visuel: 'Visuel',
    actionLogistique: 'Action à réaliser',
    ville: 'Ville',
    reseauFaceTags: 'Sous réseau',
    codePostal: 'CP',
    campagnePrec: 'Visuel préc.',
    materielDisposition: 'Disp.',
    tourneeLibelle: 'Liste d\'affichage',
    afficheur: 'Afficheur(s)',
    affectation: 'Affectation catalogue',
    affectationLogistique: 'Demande commerciale',
    multiaffectation: 'Multi-affectation',
    instructionPose: 'Instruction de pose',
    actionLogistiqueValues: {
      Aucun: 'Aucun',
      LaisserEnPlace: 'Laisser en place',
      LaisserEnPlaceVente: 'Laisser en place',
      Affichage: 'Affichage',
      Manuel: 'Affichage',
    },
    commandeTitle: 'Commande',
    anneeSemaine: 'S{semaine} - {annee}',
    anneeSemaineTitle: 'Semaine',
    ordreTravailId: 'OT',
    dateDepartCommerciale: 'Pour le',
    nomAgence: 'Agence',
    commentaire: 'Commentaire',
  },
  informationReseau: {
    title: '{libelle} - {date} - S{anneeSemaine}',
    titleReseauLc: '{libelle} - {dateDebut} - {dateFin}',
    titleReseau: '{libelle} ',
    faceAffectees: ' {faceAffecte} faces affectées /',
    facesVendues: ' {faceVendu} faces vendues',
    faceAffectee: '{faceAffecte} face affectée /',
    faceVendue: '{faceVendu} face vendue',
    restriction: '{restriction} restriction d’affichage',
    restrictions: '{restriction} restrictions d’affichage',
    faceAaffecter: 'Faces à affecter',
    noAffectation: 'Aucune face affectée à ce produit',
    restrictionAffichage: 'Restriction :',
    afficherFace: 'Afficher les faces affectées',
    afficherFaceReseau: 'Afficher les faces du réseau',
    afficherFaceVentePartielle: 'Afficher faces voulues',
    actions: {
      desaffecter: 'Désaffecter',
    },
  },
  popUpDesaffecter: {
    title: 'Etes-vous sûr de vouloir désaffecter?',
  },
  affecter: 'Affectée',
  nonAffecter: 'Non affectée',
  aucun: 'Aucun',
  laisserEnPlace: 'Laisser en place',
  affichage: 'Affichage',
  popUpActionAffecter: {
    title: 'Modifier l\'action d\'affichage',
    actionAffichage: 'Action d\'affichage',
    success: 'Action d\'affichage modifiée avec succès.',
    messageAction: 'Activer les faces pour lesquelles vous voulez forcer l\'action d\'affichage.',
  },
  popUpInstructionPose: {
    title: 'Modifier l\'instruction de pose',
    instructionPose: 'Instruction de pose',
    success: 'Instruction de pose modifiée avec succès.',
  },
  popUpAffectationListeAffichage: {
    title: 'Modifier l\'affectation à une liste d\'affichage',
    listeAffichage: 'Liste d\'affichage',
    success: 'Affectation à la liste d\'affichage modifiée avec succès.',
  },
  popUpPreventionLaisserEnPlace: {
    titleAdd: 'Ajouter un laisser en place.',
    titleRemove: 'Etes-vous sûr de vouloir enlever le laisser en place ?',
    successAdd: 'Laisser en place ajouté avec succès.',
    successRemove: 'Laisser en place enlevé avec succès.',
    errorImpossibleEnlverLaisserEnPace: 'Pour enlever l\'état "Laisser en place" la face doit être à l\'état "laisser en place".',
    laisserEnPlaceVente: 'La mise en place de ce "laisser en place" prime sur les affectations automatiques',
    messageAction: 'Activer les faces pour lesquelles vous voulez forcer le Laisser en place',
  },
  warningCard: {
    titleWarningMulti: '{nbreFaces} des faces sont dans une vente cette semaine.',
    titleWarningSingle: '1 des faces est dans une vente cette semaine.',
    informationSelected: 'Nombre faces où l\'action sera forcée : {nbFacesSelected} ',
    faceSurVenteReseau: 'La face est dans une vente réseau {libelleReseau} pour cette semaine.',
    faceSurVenteReseauNonGere: 'La face est dans une vente réseau {libelleReseau} non gérée par la logistique.',
    faceSurVenteLc: 'La face est dans une vente Lc.',
    faceSurVenteLcNonGere: 'La face est dans une vente Lc non gérée pas la logistique.',
    tab: {
      codeFace: 'Face',
      motif: 'Motif',
      commande: 'Commande',
    },
  },
};

export default AFFECTATION;
